// PluginContract_LinkNode.ts
export const LinkNodeContract = {
  pluginName: 'LinkPlugin',
  nodeTypes: ['LinkNode'],
  register: (editor: any) => {
    editor.registerNodeType?.('LinkNode');
    console.log('🔌 [LinkPlugin] Registered LinkNode');
  },
};